import cls from "./Text.module.scss";
import { classNames } from "../../lib/classNames/classNames";
import { useFlexibleResponsiveValue } from "../../hooks/useResponsiveValue/useResponsiveValue";

/**
 * @typedef {'black' | 'white' | 'grey' | 'blue' | 'linear'} TextVariant
 * @typedef {'right' | 'left' | 'center'} TextAlign
 * @typedef {'wrap' | 'left' | 'center'} TextSpaces
 * @typedef {'caption' | 'm' | 'm-strong' | 'l' | 'l-strong' | 'xl' | 'xl-strong' | 'xxl' | 'xxl-strong'| 'big' | 'big-strong'} TextSize
 */

/**
 * @typedef {Object} TextProps
 * @property {string} [className] - Дополнительный CSS класс
 * @property {string} [title] - Заголовок
 * @property {string} [text] - Текст
 * @property {TextVariant} [variant] - Цвет текста
 * @property {TextAlign} [align] - Выравнивание текста
 * @property {TextSize} [size] - Размер текста
 * @property {boolean} [bold] - Сделать текст жирным
 * @property {boolean} [heading] - Сделать текст жирным
 * @property {string | Object} [fontSize]
 * @property {boolean} [italic]
 */

/** @type {Object.<TextSize, string>} */
const mapSizeToClass = {
    caption: "caption",
    m: "sizeM",
    "m-strong": "sizeMStrong",
    l: "sizeL",
    "l-strong": "sizeLStrong",
    xl: "sizeXl",
    "xl-strong": "sizeXlStrong",
    xxl: "sizeXxl",
    "xxl-strong": "sizeXxlStrong",
    big: "sizeBig",
    "big-strong": "sizeBigStrong",
};

/** @type {Object.<TextSize, string>} */
const mapSizeToHeaderTag = {
    m: "h3",
    "m-strong": "h3",
    l: "h2",
    "l-strong": "h2",
    xl: "h1",
    "xl-strong": "h1",
};

/**
 * @param {TextProps} props
 */
export const Text = (props) => {
    const {
        className,
        text,
        title,
        variant = "black",
        align = "left",
        size = "m",
        bold,
        fontSize,
        italic,
        heading = true,
    } = props;

    const resolvedSize = useFlexibleResponsiveValue(size);
    const resolvedAlign = useFlexibleResponsiveValue(align);
    const resolvedFontSize = useFlexibleResponsiveValue(fontSize);

    const HeaderTag = mapSizeToHeaderTag[resolvedSize] || "h4";
    const sizeClass = mapSizeToClass[resolvedSize];

    const additionalClasses = [className, cls[variant], cls[resolvedAlign], cls[sizeClass]];

    return (
        <div className={classNames(cls.textWrapper, { [cls.bold]: bold }, additionalClasses)}>
            {title && heading ? (
                <HeaderTag
                    style={{ fontSize: resolvedFontSize }}
                    className={classNames(cls.title, { [cls.italic]: italic }, [])}
                >
                    {title}
                </HeaderTag>
            ) : (
                title && (
                    <p
                        style={{ fontSize: resolvedFontSize }}
                        className={classNames(cls.title, { [cls.italic]: italic }, [])}
                    >
                        {title}
                    </p>
                )
            )}
            {text && (
                <p
                    style={{ fontSize: resolvedFontSize }}
                    className={classNames(cls.text, { [cls.italic]: italic }, [])}
                >
                    {text}
                </p>
            )}
        </div>
    );
};
